import { useFormikContext } from 'formik';
import { useMemo } from 'react';
import { Box } from 'src/components/Box';
import { Stack } from 'src/components/Stack';

import { FormValues } from './ManageSchedule';

type PlanDaysProps = {
  days: string[];
  readOnly: boolean;
};

export const PlanDays = ({ days, readOnly }: PlanDaysProps) => {
  const { setFieldValue } = useFormikContext<FormValues>();

  const dayOptions = useMemo(() => {
    return [
      { title: 'S', value: 'sunday' },
      { title: 'M', value: 'monday' },
      { title: 'T', value: 'tuesday' },
      { title: 'W', value: 'wednesday' },
      { title: 'Th', value: 'thursday' },
      { title: 'F', value: 'friday' },
      { title: 'Sa', value: 'saturday' },
    ];
  }, []);

  const dayValues = useMemo(() => {
    return dayOptions.map((day) => day.value);
  }, [dayOptions]);

  return (
    <Stack direction="row" spacing={1}>
      {dayOptions.map((day) => (
        <Box
          component="button"
          type="button"
          key={day.value}
          sx={{
            width: '24px',
            height: '24px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            padding: '4px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            userSelect: 'none',
            backgroundColor: days.includes(day.value)
              ? 'text.secondary'
              : 'background.level1',
            color: days.includes(day.value) ? 'common.white' : 'text.primary',
          }}
          disabled={readOnly}
          onClick={() => {
            if (days.includes(day.value)) {
              setFieldValue(
                'days',
                days.filter((d) => d !== day.value)
              );
            } else {
              setFieldValue(
                'days',
                dayValues.filter((d) => [...days, day.value].includes(d))
              );
            }
          }}
        >
          {day.title}
        </Box>
      ))}
    </Stack>
  );
};
